import styled from '@emotion/styled'

/**
 * Hero — 헤드라인 + 검색바 (피그마 노드 16218:21031)
 *
 * 패딩: top 40 / bottom 16, 좌우 20
 * 갭: 헤드라인 ↔ 검색바 16px
 */
export const HeroWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  padding: 40px 20px 16px;
  background: #ffffff;
`

/**
 * 헤드라인 — 28px Bold, lh 38, ls -0.42
 * "주말, 공휴일" 부분만 #ff5626 강조
 */
export const Headline = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.42px;
  color: #1b1c1d;
  text-align: center;
`

export const HeadlineEmphasis = styled.span`
  color: #ff5626;
`

/**
 * 검색바 — placeholder만, 클릭 시 다음 주소검색 popup (다음 단계에서 연결)
 *
 * - 높이 52, 좌우 16, 갭 10
 * - 배경 #f5f5f6, rounded 14
 * - 너비 100% (Figma는 350고정이지만 좌우 padding 20을 고려하면 결국 100%)
 */
export const SearchTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 52px;
  padding: 0 16px;
  border: 0;
  border-radius: 14px;
  background: #f5f5f6;
  cursor: pointer;

  &:active {
    background: #eeeff0;
  }
`

export const SearchPlaceholder = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #acaeb4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
